import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function PersonSolid({
  size = sizes.X_SMALL,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 10 10"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        d="M8.86006 9.80823V9.81382C8.86006 9.91655 8.7768 9.99993 8.67395 9.99993H0.18611C0.083253 9.99993 0 9.91655 0 9.81382V9.80823C0 9.21032 0.117125 8.63003 0.348149 8.08387C0.571356 7.55631 0.89072 7.08247 1.29756 6.67576C1.70427 6.26892 2.17798 5.94956 2.70554 5.72635C3.25183 5.49533 3.832 5.3782 4.43003 5.3782C5.02806 5.3782 5.60823 5.49533 6.15452 5.72635C6.68208 5.94956 7.15579 6.26892 7.56262 6.67576C7.96934 7.08247 8.2887 7.55631 8.51191 8.08387C8.74293 8.63003 8.86006 9.21032 8.86006 9.80823Z"
        fill={colour}
      />
      <path
        d="M2.17382 3.39997C2.04627 3.09823 1.98151 2.77762 1.98151 2.44734C1.98151 2.11706 2.04627 1.79645 2.17382 1.49471C2.29715 1.20326 2.47358 0.94159 2.69828 0.71677C2.9231 0.492074 3.18477 0.315642 3.47621 0.192437C3.77796 0.0647661 4.09856 0 4.42885 0C4.75913 0 5.07973 0.0647661 5.38148 0.192437C5.67293 0.315642 5.9346 0.492074 6.15942 0.71677C6.38411 0.94159 6.56055 1.20326 6.68387 1.49471C6.81142 1.79645 6.87619 2.11706 6.87619 2.44734C6.87619 2.77762 6.81142 3.09823 6.68387 3.39997C6.56055 3.69142 6.38411 3.95309 6.15942 4.17791C5.9346 4.40261 5.67293 4.57904 5.38148 4.70224C5.07973 4.82991 4.75913 4.89468 4.42885 4.89468C4.09856 4.89468 3.77796 4.82991 3.47621 4.70224C3.18477 4.57904 2.9231 4.40261 2.69828 4.17791C2.47358 3.95309 2.29715 3.69142 2.17382 3.39997Z"
        fill={colour}
      />
    </svg>
  )
}

PersonSolid.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
